import { render, staticRenderFns } from "./userAddRelationship.vue?vue&type=template&id=a4121770&scoped=true"
import script from "./userAddRelationship.vue?vue&type=script&lang=js"
export * from "./userAddRelationship.vue?vue&type=script&lang=js"
import style0 from "./userAddRelationship.vue?vue&type=style&index=0&id=a4121770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4121770",
  null
  
)

export default component.exports